
import { defineComponent, onMounted, ref, watch } from "vue";
import { hideModal, modalHideListener } from "@/core/helpers/dom";
import { ApiMerchant } from "@/core/api";
import mixin from "@/mixins";

export default defineComponent({
  name: "add-key-parameters-modal",
  props: {
    id: { type: Number, default: 0 },
    merchantId: { type: Number, default: 0 },
  },
  components: {},
  emits: ["update-list", "reset-form"],
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const addkeyParametersModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      id: props.id,
      merchant_id: props.merchantId,
      fiscal_year: "",
      revenue: "",
      employees: "",
    });

    watch(
      () => props.id,
      (newVal) => {
        console.log(newVal);
        if (newVal) {
          getFormData(newVal);
        } else {
          resetForm();
        }
      }
    );

    const rules = ref({
      fiscal_year: [
        {
          required: true,
          message: "Fiscal Year is required",
          trigger: "change",
        },
      ],
      revenue: [
        {
          required: true,
          message: "Revenue is required",
          trigger: "change",
        },
      ],
      employees: [
        {
          required: true,
          message: "Employees is required",
          trigger: "change",
        },
      ],
    });

    const getFormData = (id) => {
      if (id) {
        loading.value = true;
        ApiMerchant.getFiscalHistoryInfo({ id: id })
          .then(({ data }) => {
            loading.value = false;
            if (data.code == 0) {
              let year = {
                fiscal_year: String(data.data.fiscal_year),
              };
              formData.value = { ...data.data, ...year };
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          if (props.id) {
            editKeyarameters();
          } else {
            addKeyarameters();
          }
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const addKeyarameters = () => {
      ApiMerchant.addFiscalHistory(formData.value)
        .then(({ data }) => {
          loading.value = false;
          submitButton.value?.removeAttribute("data-kt-indicator");
          if (data.code == 0) {
            showFormSubmitSuccessMsg(() => {
              resetForm();
              hideModal(addkeyParametersModalRef.value);
              emit("update-list");
            });
          } else {
            showServerErrorMsg(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const editKeyarameters = () => {
      ApiMerchant.updateFiscalHistory(formData.value)
        .then(({ data }) => {
          loading.value = false;
          submitButton.value?.removeAttribute("data-kt-indicator");
          if (data.code == 0) {
            showFormSubmitSuccessMsg(() => {
              resetForm();
              hideModal(addkeyParametersModalRef.value);
              emit("update-list");
            });
          } else {
            showServerErrorMsg(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleDiscard = () => {
      hideModal(addkeyParametersModalRef.value);
      resetForm();
      emit("reset-form");
    };

    onMounted(() => {
      modalHideListener(addkeyParametersModalRef.value, () => {
        emit("reset-form");
      });
    });

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    return {
      loading,
      formData,
      rules,
      formRef,
      addkeyParametersModalRef,
      submitButton,
      getFormData,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
